import React from "react";
import { FieldArray } from "react-final-form-arrays";

import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

import { Button, FormLabel, IconButton } from "@material-ui/core";

import { TextFieldControl } from "components/FormControl";

import { Container, Column, Wrapper, TitleRow, Row } from "./styles";

type Props = { name: string };

class IngredientsControl extends React.Component<Props> {
  render() {
    const { name } = this.props;

    return (
      <Container>
        <TitleRow>
          <FormLabel>Ingredients</FormLabel>
        </TitleRow>
        <TitleRow>
          <Column width="250px">
            <FormLabel required>Ingredient</FormLabel>
          </Column>
          <Column width="150px">
            <FormLabel required>Quantity</FormLabel>
          </Column>
          <Column width="50px" />
        </TitleRow>

        <FieldArray name={name}>
          {({ fields }) => (
            <>
              {fields.map((ingredient, index) => (
                <>
                  <Row key={`ingredient_index:${index}`}>
                    <Column width="250px">
                      <TextFieldControl
                        name={`${ingredient}.title`}
                        variant="outlined"
                        margin="none"
                        placeholder="Enter ingredient"
                        required
                      />
                    </Column>
                    <Column width="150px">
                      <TextFieldControl
                        name={`${ingredient}.unit`}
                        variant="outlined"
                        margin="none"
                        placeholder="Enter quantity"
                        required
                      />
                    </Column>
                    <Column width="50px">
                      {fields.length !== 1 && (
                        <Wrapper>
                          <IconButton
                            color="secondary"
                            onClick={() => fields.remove(index)}
                          >
                            <DeleteOutlineIcon />
                          </IconButton>
                        </Wrapper>
                      )}
                    </Column>
                  </Row>
                </>
              ))}
              <Row>
                <Column width="432px">
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => fields.push({})}
                  >
                    Add Ingredient
                  </Button>
                </Column>
              </Row>
            </>
          )}
        </FieldArray>
      </Container>
    );
  }
}

export default IngredientsControl;
